import { render } from "./ExpensesPageShell.vue?vue&type=template&id=49043af2&scoped=true"
import script from "./ExpensesPageShell.vue?vue&type=script&lang=js"
export * from "./ExpensesPageShell.vue?vue&type=script&lang=js"

import "./ExpensesPageShell.vue?vue&type=style&index=0&id=49043af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49043af2"]])

export default __exports__